import { __assign, __rest } from "tslib";
import { Columns } from '@trilogy-ds/react/lib/components/columns';
import { Spacer, SpacerSize } from '@trilogy-ds/react/lib/components/spacer';
import { hashClass } from '@trilogy-ds/react/lib/helpers';
import { has, is } from '@trilogy-ds/react/lib/services';
import clsx from 'clsx';
import * as React from 'react';
import { useTrilogyContext } from '../../context';
import { Icon, IconName, IconSize } from '../icon';
/**
 * Slider component
 * @param children {ReactNode} Slider child
 * @param doted {boolean} slide dot
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal css classes
 * @param iconClassName {string} Additionnal css classes for Icon
 * @param motionLess {boolean} Disable behaviour on desktop
 * @param autoSlideDelay {number} Auto-slide delay in MS
 * @param invertedDoted {boolean} Inverted dots color
 * @param progressBar {boolean} Show Progress bars
 * @param arrowsOut {boolean} Slider arrows outside
 * @param arrowSize {IconSize} Icon Arrows Sizes
 * - -------------------------- NATIVE PROPERTIES -------------------------------
 * @param showNextSlide {boolean} show next slide
 * @param contentSize {number} size of slide
 */
var Slider = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName, children = _a.children, motionLess = _a.motionLess, doted = _a.doted, autoSlideDelay = _a.autoSlideDelay, invertedDoted = _a.invertedDoted, progressBar = _a.progressBar, bars = _a.bars, isBarsOut = _a.isBarsOut, arrowsOut = _a.arrowsOut, arrowSize = _a.arrowSize, others = __rest(_a, ["className", "iconClassName", "children", "motionLess", "doted", "autoSlideDelay", "invertedDoted", "progressBar", "bars", "isBarsOut", "arrowsOut", "arrowSize"]);
    var styled = useTrilogyContext().styled;
    var classes = hashClass(styled, clsx(motionLess && is('motionless-desktop'), className));
    var iconSliderClasses = "".concat(has('background-white'), " ").concat(has('text-main'), " ").concat(is('circled'), " ").concat(iconClassName && iconClassName);
    return (React.createElement("div", __assign({ className: classes, "data-slider": true }, others),
        React.createElement("div", { "data-slider-duration": autoSlideDelay || 0 }),
        React.createElement(Columns, { className: arrowsOut ? 'is-variable is-10' : '', mobile: true, "data-slides-container": true },
            !motionLess && (React.createElement(Icon, { "data-slider-prev": true, size: arrowSize || IconSize.MEDIUM, className: iconSliderClasses, name: IconName.ARROW_LEFT })),
            children,
            !motionLess && (React.createElement(Icon, { "data-slider-next": true, size: arrowSize || IconSize.MEDIUM, className: iconSliderClasses, name: IconName.ARROW_RIGHT }))),
        doted && !progressBar && (React.createElement("div", { "data-slider-dots": true, className: invertedDoted ? hashClass(styled, clsx(is('inverted'))) : '' })),
        progressBar && !doted && React.createElement("div", { "data-progress-bar-container": true }),
        bars && !doted && (React.createElement(React.Fragment, null,
            React.createElement("div", { "data-slider-bars": true, className: isBarsOut ? hashClass(styled, clsx('is-outside')) : '' }),
            React.createElement(Spacer, { size: SpacerSize.SIX })))));
};
export default Slider;
//# sourceMappingURL=Slider.js.map